__turbopack_context__.v({
  "normalize": "fIRpXW_normalize",
});
